import React from 'react';

const CompGroupDialogContext = React.createContext({});
export default CompGroupDialogContext;
